import {configure, defineRule} from "vee-validate";
import AllRules from '@vee-validate/rules';
import {localize, setLocale} from '@vee-validate/i18n';

// @ts-ignore
import en from '@vee-validate/i18n/dist/locale/en.json';
// @ts-ignore
import ar from '@vee-validate/i18n/dist/locale/ar.json';

export function initVeeValidate() {
    // Updating default vee-validate configuration
    configure({
        validateOnBlur: true,
        validateOnChange: true,
        validateOnInput: true,
        validateOnModelUpdate: true,
        generateMessage: localize({
            en,
            ar,
        }),
    });
    Object.keys(AllRules).forEach(rule => {
        defineRule(rule, AllRules[rule]);
    });
    const lang: any = localStorage.getItem("lang") ? localStorage.getItem("lang") : 'en';
    setLocale(lang);
}
